@if (config()) {
  <div class="parameter-selection-config">
    @if (config()) {
      <mat-form-field
        class="parameter-selection-config__field without-subscript small-form-field"
        appearance="outline"
      >
        @if (!hideLabel()) {
          <mat-label>{{ parameterTitle }}</mat-label>
        }
        <mat-select
          [value]="value()"
          [disabled]="disabled()"
          (selectionChange)="onSelectionChange($event, config())"
          [attr.data-testid]="'parameter-selection-config-' + config().parameterId"
        >
          @for (option of validEnumCoding | keyvalue; track option) {
            <mat-option [value]="option.key" class="parameter-selection-config__option">
              <span class="parameter-selection-config__text" [innerHTML]="option.value"></span>
            </mat-option>
          }
        </mat-select>
        <span matTextSuffix>{{ config().parameter.unit }}</span>
      </mat-form-field>
    }
    @if (config().parameter.description && showInfo()) {
      <div class="small-icon-button-wrapper">
        <button mat-icon-button>
          <mat-icon
            class="parameter-selection-config__icon"
            color="primary"
            [matTooltip]="config().parameter.description"
            >info_outline
          </mat-icon>
        </button>
      </div>
    }
    @if (!disabled()) {
      @if (value() && !readonly() && hasDelete()) {
        <div class="small-icon-button-wrapper">
          <button mat-icon-button>
            <mat-icon
              (click)="onClickRemove()"
              class="parameter-selection-config__close"
              color="warn"
              matTooltip="Discard changes"
              >close
            </mat-icon>
          </button>
        </div>
      }
      @if (value() && !readonly() && hasUndo()) {
        <div class="small-icon-button-wrapper">
          <button mat-icon-button>
            <mat-icon
              (click)="onClickUndo()"
              class="parameter-selection-config__close"
              color="warn"
              matTooltip="Discard changes"
              >close
            </mat-icon>
          </button>
        </div>
      }
      @if (hasClose()) {
        <div class="small-icon-button-wrapper">
          <button mat-icon-button>
            <mat-icon (click)="onClickClose()" matTooltip="Close">close</mat-icon>
          </button>
        </div>
      }
      @if (showReset()) {
        <div class="small-icon-button-wrapper">
          <button
            mat-icon-button
            (click)="onResetToFactory()"
            [matTooltip]="resetToFactoryTooltip()"
          >
            <mat-icon color="warn">replay</mat-icon>
          </button>
        </div>
      }
    }
  </div>
}
